module.exports = __webpack_public_path__ + "img/abstract_4.18e993aa.png";